export interface CheckboxRequiredBounds {
  maxRequired: number | null;
  minRequired: number;
}

export const checkboxQueries = {
  clampCheckboxRequiredBounds(args: {
    maxRequired: number | null;
    minRequired: number;
    optionCount: number;
  }): CheckboxRequiredBounds {
    const { optionCount } = args;
    let { maxRequired, minRequired } = args;

    minRequired = Math.min(Math.max(0, minRequired), optionCount);

    if (maxRequired !== null) {
      if (optionCount === 0) {
        maxRequired = null;
      } else {
        maxRequired = Math.min(Math.max(1, maxRequired), optionCount);
      }
    }

    if (maxRequired !== null && minRequired > maxRequired) {
      minRequired = maxRequired;
    }

    return { maxRequired, minRequired };
  },

  getIsCheckboxComplete(args: {
    maxRequired: number | null;
    minRequired: number;
    selectedCount: number;
    skipped: boolean;
  }): boolean {
    const { maxRequired = null, minRequired = 0, selectedCount, skipped } = args;

    if (skipped && selectedCount === 0) return minRequired === 0;
    if (selectedCount === 0) return false;
    if (selectedCount < minRequired) return false;
    if (maxRequired !== null && selectedCount > maxRequired) return false;

    return true;
  },
};
